import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys} from 'procedures/ProceduresStringKeys';

import {ExperimentalInputsComponentName} from './ProcedurePlanTypes';

export const TABLE_NAME_BY_COMPONENT_NAME: Record<ExperimentalInputsComponentName, string> = {
  [ExperimentalInputsComponentName.PARAMETERS]: 'Parameters',
  [ExperimentalInputsComponentName.MATERIAL_INPUTS]: 'Material inputs',
  [ExperimentalInputsComponentName.EQUIPMENT]: 'Equipment',
};

export function getDefaultLabelByComponentNameAndProcedureType(
  experimentalInputsComponentName: ExperimentalInputsComponentName,
  procedureType: ProcedureType
): string {
  return `${getProcedureUIString(ProceduresStringKeys.PROCEDURE, procedureType)} ${
    DEFAULT_LABEL_BY_COMPONENT_NAME[experimentalInputsComponentName]
  }`;
}

export function getEquipmentModelsLabelByProcedureType(procedureType: ProcedureType): string {
  return `${getProcedureUIString(ProceduresStringKeys.PROCEDURE, procedureType)} model(s)`;
}

export const DEFAULT_LABEL_BY_COMPONENT_NAME: Record<ExperimentalInputsComponentName, string> = {
  [ExperimentalInputsComponentName.PARAMETERS]: 'setpoint',
  [ExperimentalInputsComponentName.MATERIAL_INPUTS]: 'values',
  [ExperimentalInputsComponentName.EQUIPMENT]: 'default equipment',
};
